import { SET_UX_SIGNAL_STATUS } from '../reducers/uxSignal';

export const acSetUxSignalStatus = (status) => ({
  type: SET_UX_SIGNAL_STATUS,
  payload: status,
});
